import React from "react";
import { Row, Col } from "reactstrap";
import BlockMapa from "./vista-inicio-block-mapa.block";
import BlockTematicas from "./vista-inicio-block-tematicas.block";
import "./vista-inicio.view.scss";
class VistaInicio extends React.Component {
  render2() {
    return (
      <div className="vista-inicio">
        <BlockMapa />
        <BlockTematicas />
      </div>
    );
  }
  render() {
    return (
      <Row>
        <Col sm="12" lg="6">
          <BlockMapa />
        </Col>
        <Col sm="12" lg="6">
          <BlockTematicas />
        </Col>
      </Row>
    );
  }
}
export default VistaInicio;
